export const ECOSYSTEM_LINKS = {
  explorer: 'https://explorer.cratd2csmartchain.io',
  bridge: 'https://bridge.cratd2csmartchain.io/',
  smartSwap: 'https://smart-swap.cratd2csmartchain.io',
  staking: 'https://staking.cratd2csmartchain.io',
  trading: 'https://crat-dex-frontend.vercel.app/#',
  tap2mine: 'https://cratd2csmartchain.io/tap2mine',
  intellectualProperty: 'https://cratd2csmartchain.io/intellectual-property',
  useCases: 'https://cratd2csmartchain.io/use-cases',
};
